import { z } from 'zod';

export const OptionSchema = z.object({
  id: z.number(),
  assessmentId: z.number(),
  text: z.string(),
  textAr: z.string().nullable(),
  from: z.number().nullable(),
  to: z.number().nullable(),
  isOther: z.boolean(),
});
export const AssessmentContextSchema = z.enum([
  'LEARNING_HOURS',
  'INTERESTED_TOPIC',
  'SUB_TOPIC',
]);
export type AssessmentContextType =
  (typeof AssessmentContextSchema)[keyof typeof AssessmentContextSchema];
const OrganizationAssessmentSchema = z.object({
  id: z.number(),
  title: z.string(),
  titleAr: z.string(),
  isMultiple: z.boolean(),
  context: AssessmentContextSchema.nullable(),
  description: z.string().nullable(),
  descriptionAr: z.string().nullable(),

  options: z.array(OptionSchema),
});
export const UserAnswersSchema = z.object({
  optionId: z.number(),
  customAnswer: z.string().nullable(),
});
export type UserAnswers = z.infer<typeof UserAnswersSchema>;

export type AssessmentOptions = z.infer<typeof OptionSchema>;
export type OrganizationAssessments = z.infer<
  typeof OrganizationAssessmentSchema
>;
